'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024$0024anon$00248 from "./com.raquo.airstream.core.-Observer$$anon$8.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024$0024anon$00249 from "./com.raquo.airstream.core.-Observer$$anon$9.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dPartial$002dFunction$0024 from "./scala.-Partial-Function$.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$() {
  this.DC = null;
  $n_Lcom_raquo_airstream_core_Observer$ = this;
  this.DC = $m_Lcom_raquo_airstream_core_Observer$().jy(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (void 0))), $j_scala$002e$002dPartial$002dFunction$0024.$m_s_PartialFunction$().gb, true);
}
export { $c_Lcom_raquo_airstream_core_Observer$ as $c_Lcom_raquo_airstream_core_Observer$ };
$p = $c_Lcom_raquo_airstream_core_Observer$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$() {
}
export { $h_Lcom_raquo_airstream_core_Observer$ as $h_Lcom_raquo_airstream_core_Observer$ };
$h_Lcom_raquo_airstream_core_Observer$.prototype = $p;
$p.jy = (function(onNext, onError, handleObserverErrors) {
  return new $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024$0024anon$00248.$c_Lcom_raquo_airstream_core_Observer$$anon$8(onNext, handleObserverErrors, onError, this);
});
$p.UL = (function(onTry, handleObserverErrors) {
  return new $j_com$002eraquo$002eairstream$002ecore$002e$002dObserver$0024$0024anon$00249.$c_Lcom_raquo_airstream_core_Observer$$anon$9(onTry, handleObserverErrors, this);
});
var $d_Lcom_raquo_airstream_core_Observer$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Observer$, "com.raquo.airstream.core.Observer$", ({
  gK: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$ as $d_Lcom_raquo_airstream_core_Observer$ };
var $n_Lcom_raquo_airstream_core_Observer$;
function $m_Lcom_raquo_airstream_core_Observer$() {
  if ((!$n_Lcom_raquo_airstream_core_Observer$)) {
    $n_Lcom_raquo_airstream_core_Observer$ = new $c_Lcom_raquo_airstream_core_Observer$();
  }
  return $n_Lcom_raquo_airstream_core_Observer$;
}
export { $m_Lcom_raquo_airstream_core_Observer$ as $m_Lcom_raquo_airstream_core_Observer$ };
